var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeEvery } from "redux-saga/effects";
import logger from "../../logger";
import * as quoteActions from "../quote/quote.actions";
import { getQuoteStartFlow } from "../quote/quote.saga";
import * as agreementActions from "./agreement.actions";
import * as agreementApi from "./agreement.api";
function getAgreementStartFlow(action) {
    var payload, leadId, quoteId, agreementId, publicId, agreement, unknownError_1, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                leadId = payload.leadId, quoteId = payload.quoteId, agreementId = payload.agreementId, publicId = payload.publicId;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(agreementApi.getAgreement, leadId, quoteId, agreementId, publicId)];
            case 2:
                agreement = (_a.sent()).data;
                return [4 /*yield*/, put(agreementActions.getAgreement.actions.success({
                        leadId: leadId,
                        quoteId: quoteId,
                        agreementId: agreementId,
                        agreement: agreement,
                    }))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                unknownError_1 = _a.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [4 /*yield*/, put(agreementActions.getAgreement.actions.failure({
                        leadId: leadId,
                        quoteId: quoteId,
                        agreementId: agreementId,
                        error: error,
                    }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function createAgreementStartFlow(action) {
    var payload, leadId, quoteId, publicId, agreement, unknownError_2, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                leadId = payload.leadId, quoteId = payload.quoteId, publicId = payload.publicId;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(agreementApi.createAgreement, leadId, quoteId, publicId)];
            case 2:
                agreement = (_a.sent()).data;
                return [4 /*yield*/, call(getQuoteStartFlow, quoteActions.getQuote.actions.start({
                        leadId: leadId,
                        quoteId: quoteId,
                        publicId: publicId,
                    }))];
            case 3:
                _a.sent();
                return [4 /*yield*/, put(agreementActions.createAgreement.actions.success({
                        leadId: leadId,
                        quoteId: quoteId,
                        agreement: agreement,
                    }))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                unknownError_2 = _a.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                return [4 /*yield*/, put(agreementActions.createAgreement.actions.failure({
                        leadId: leadId,
                        quoteId: quoteId,
                        error: error,
                    }))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function mailAgreementStartFlow(action) {
    var payload, leadId, quoteId, agreementId, publicId, unknownError_3, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                leadId = payload.leadId, quoteId = payload.quoteId, agreementId = payload.agreementId, publicId = payload.publicId;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(agreementApi.mailAgreement, leadId, quoteId, agreementId, publicId)];
            case 2:
                _a.sent();
                return [4 /*yield*/, put(agreementActions.mailAgreement.actions.success({
                        leadId: leadId,
                        quoteId: quoteId,
                        agreementId: agreementId,
                    }))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                unknownError_3 = _a.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                return [4 /*yield*/, put(agreementActions.mailAgreement.actions.failure({
                        leadId: leadId,
                        quoteId: quoteId,
                        agreementId: agreementId,
                        error: error,
                    }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(agreementActions.getAgreement.types.START, getAgreementStartFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(agreementActions.createAgreement.types.START, createAgreementStartFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(agreementActions.mailAgreement.types.START, mailAgreementStartFlow)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// eslint-disable-next-line import/no-default-export
export default saga;
